const chartColors = [
	'#3366cc',
	'#dc3912',
	'#ff9900',
	'#109618',
	'#990099',
	'#0099c6',
	'#dd4477',
	'#66aa00',
	'#b82e2e',
	'#316395',
	'#3366cc',
	'#994499',
	'#22aa99',
	'#aaaa11',
	'#6633cc',
	'#e67300',
	'#8b0707',
	'#651067',
	'#329262',
	'#5574a6',
	'#3b3eac',
	'#b77322',
	'#16d620',
	'#b91383',
	'#f4359e',
	'#9c5935',
	'#a9c413',
	'#2a778d',
	'#668d1c',
	'#bea413',
	'#0c5922',
	'#743411'
];

export const getRandomColor = () => {
	let letters = '0123456789ABCDEF';
	let color = '#';
	for (let i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * 16)];
	}
	return color;
};
export const getColor = (i) => {
	return i >= chartColors.length ? getRandomColor() : chartColors[i];
};
export const getColors = (numOfColors = chartColors.length) => {
	let colors = [];
	if (numOfColors > 0) {
		for (let i = 0; i < numOfColors; i++) {
			colors.push(getColor(i));
		}
	}
	if (numOfColors > 0 && numOfColors < colors.length) {
		colors = colors.slice(0, numOfColors - 1);
	}
	return colors;
};
export default chartColors;

